
import { defineComponent, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import { ROLE_SLUGS, isUserRole } from '@/utils/roles'

export default defineComponent({
  components: { LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()

    const isLabo = computed(() =>
      isUserRole(['real_trade_lab']) || isUserRole(['trial_trade_lab_202409'])
    )
    const isShindo = computed(() => isUserRole([ROLE_SLUGS.shindo]))

    return {
      t,
      isLabo,
      isShindo
    }
  },
})
